// extracted by mini-css-extract-plugin
export default {"radio":"R67joa","checked":"_hoyaL","disabled":"lIhOdK","selector":"O2cESz","label":"SsksLM"};